var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_37)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0006 9.62457H21.2089C21.3251 14.6523 22.7285 15.223 24.4921 15.3885L25.1719 15.4741V21.0011L24.3881 20.9583C22.0847 20.8265 19.5403 20.4053 17.8419 18.2761C16.3531 16.4077 15.6969 13.3574 15.6969 8.67438V0H28.0006V9.62457Z",
    fill: "#030870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3036 0V9.62457H5.60236C5.71865 14.6523 7.07711 15.223 8.84006 15.3885L9.47491 15.4741V21.0011L8.73669 20.9583C6.43327 20.8265 3.86637 20.4053 2.16802 18.2761C0.678665 16.4077 0 13.3574 0 8.67438V0H12.3036Z",
    fill: "#030870"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperQuotes);
export default __webpack_public_path__ + "static/media/upper-quotes.cf80e81345f4d223353a1d71cc61f5d4.svg";
export { ForwardRef as ReactComponent };